import { render, staticRenderFns } from "./priceSwitcher.vue?vue&type=template&id=6a28dcf7&scoped=true&"
import script from "./priceSwitcher.vue?vue&type=script&lang=js&"
export * from "./priceSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./priceSwitcher.vue?vue&type=style&index=0&id=6a28dcf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28dcf7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
